import {useRouteError} from "react-router-dom";

export default function BubbleError(): never {
  const error = useRouteError() as {_isNominal?: boolean};
  if (!error._isNominal) {
    Object.defineProperty(error, "_isNominal", {get: () => true});
  }
  throw error;
}
